// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"b229e8ff9f8da50e53b1","691":"08b4f54ce382b420381b"}[chunkId] + ".js";
};